import { AdminNavigationSetup } from "@app/components/layouts/AdminNavigationSetup";
import { cn } from "@dust-tt/sparkle";
import type { ReactElement } from "react";

interface AdminLayoutProps {
  children: ReactElement;
}

export function AdminLayout({ children }: AdminLayoutProps) {
  return (
    <>
      <AdminNavigationSetup />
      <div
        className={cn("flex h-full w-full flex-col items-center pt-4 sm:pt-8")}
      >
        {/* A page marked data-fill-height scrolls its own regions, so the
            column is held to the modal's height instead of growing past it. */}
        <div className="flex w-full max-w-6xl grow flex-col px-4 sm:px-8 pb-4 sm:pb-8 has-[>[data-fill-height]]:min-h-0">
          {children}
        </div>
      </div>
    </>
  );
}
